import { FEATURED_VENUES_CHECKINS_WINDOW_DAYS, FeaturedVenueDto, VenueType } from '@ivy-monorepo/shared'

/** How many venue cards "Where will you meet?" shows (top N from /content/venues/featured). */
export const FEATURED_VENUES_LIMIT = 6

export interface VenueCardData {
  key: string
  name: string
  /** Venue type (from the API) or neighborhood (static fallback). */
  label: string
  /** Uploaded logo or the venue-type icon, shown as a faded card background. */
  logoUrl?: string
  /** Short stat line, e.g. "128 check-ins · last 30 days". */
  stat?: string
}

const VENUE_TYPE_LABELS: Record<VenueType, string> = {
  [VenueType.Bar]: 'Bar',
  [VenueType.Restaurant]: 'Restaurant',
  [VenueType.Nightclub]: 'Nightclub',
  [VenueType.Cafe]: 'Café',
  [VenueType.Coffee]: 'Coffee',
  [VenueType.Gym]: 'Gym',
  [VenueType.Bookstore]: 'Bookstore',
  [VenueType.Museum]: 'Museum',
  [VenueType.Park]: 'Park',
  [VenueType.Outside]: 'Outdoors',
  [VenueType.Shop]: 'Shop',
  [VenueType.Party]: 'Party',
  [VenueType.Movies]: 'Cinema',
  [VenueType.Concert]: 'Concert',
  [VenueType.Attraction]: 'Attraction',
  [VenueType.Other]: 'Spot',
}

const formatVenueStat = (venue: FeaturedVenueDto): string | undefined => {
  const count = venue.recentCheckins
  if (count > 0) {
    return `${count.toLocaleString('en-US')} check-in${count === 1 ? '' : 's'} · last ${FEATURED_VENUES_CHECKINS_WINDOW_DAYS} days`
  }
  return venue.isPartnerVenue ? 'Ivy partner' : undefined
}

export const toVenueCardData = (venue: FeaturedVenueDto): VenueCardData => ({
  key: venue.publicId,
  name: venue.name,
  label: VENUE_TYPE_LABELS[venue.type] ?? venue.type,
  logoUrl: venue.logoUrl || undefined,
  stat: formatVenueStat(venue),
})

/** Shown when the featured venues request fails or returns nothing. */
export const FALLBACK_VENUES: VenueCardData[] = [
  { key: 'joy-district', name: 'Joy District', label: 'River North' },
  { key: 'signature-chicago', name: 'Signature Chicago', label: 'Partner venue' },
  { key: 'pbj-west-loop', name: 'PB&J West Loop', label: 'West Loop' },
  { key: 'aliveone', name: 'aliveOne', label: 'Lincoln Park' },
  { key: 'tin-lizzie', name: 'Tin Lizzie', label: 'Lincoln Park' },
  { key: 'cubby-bear', name: 'Cubby Bear', label: 'Wrigleyville' },
]

export const VENUE_BENEFITS: string[] = [
  'Premium, branded placement on the Ivy app',
  'Boosted exposure through paid social campaigns',
  'Shareable content for your social channels',
  'Habit-building through repeat visits',
  'Amplification of your existing events',
  'Access to real-time engagement analytics',
]

export const TRUST_CHECKLIST: string[] = ['Profiles appear after check-in', 'See people checked in at the same spot', 'Check out from the app when you leave']
